import { Controller } from "@hotwired/stimulus"

// Progressive enhancement for a server-rendered <dialog open>: without JS
// it remains visible; with JS it gains the top layer, focus trap and backdrop.
export default class extends Controller {
  static targets = ["cancel"]

  connect() {
    this.enhancing = true
    if (this.element.open) this.element.close()
    this.element.showModal()
    this.enhancing = false
  }

  backdrop(event) {
    if (event.target === this.element) this.element.close()
  }

  keep(event) {
    event.stopPropagation()
  }

  closed() {
    if (!this.enhancing && !this.element.open) this.cancelTarget.click()
  }
}
